<template>
  <div id="homePage" v-if="requestDone">
    <div class="first">
      <div class="index-gif"></div>
    </div>
    <img class="second" :src="require('@/assets/happyBirthday/index-2.png')">
    <img class="third" :src="require('@/assets/happyBirthday/index-3.png')">
    <div class="button-wrap">
      <div @click="jumpPage('blessing')" class="blessing"></div>
      <div @click="jumpPage('signUp')" class="sign-up"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'homePage',
  data () {
    return {
      staffData: {},
      authKey: '',
      isIpx: false,
      requestDone: true
    }
  },
  methods: {
    jumpPage (path) {
      this.$router.push({path: path})
    }
  }
}
</script>

<style scoped lang="less">
#homePage {
  display: flex;
  flex-flow: column;
  .first {
    background-image: url('~@/assets/happyBirthday/index-1.png');
    background-position: 0 0;
    background-size: 100% 100%;
    height: 48.13rem /* 3610/75 */;
    display: flex;
    justify-content: center;
    .index-gif {
      background-image: url('~@/assets/happyBirthday/index-gif.gif');
      background-position: 0 0;
      background-size: 100% 100%;
      width: 8.64rem /* 648/75 */;
      height: 14.85rem /* 1114/75 */;
      margin-top: 33rem;
    }
  }
  .second {
    // background-image: url('~@/assets/happyBirthday/index-2.png');
    background-position: 0 0;
    background-size: 100% 100%;
    height: 55.76rem /* 4182/75 */;
  }
  .third {
    // background-image: url('~@/assets/happyBirthday/index-3.png');
    background-position: 0 0;
    background-size: 100% 100%;
    height: 41.07rem /* 3080/75 */;
  }
  .button-wrap {
    position: fixed;
    width: 100%;
    padding: .3rem .2rem .3rem .2rem;
    display: flex;
    justify-content: space-between;
    background-color: #f2dddf;
    bottom: 0;
    div {
      width: 4.64rem;
      height: 1.07rem;
      background-position: 0 0;
      background-size: 100% 100%;
    }
    .blessing {
      background-image: url('~@/assets/happyBirthday/blessing.png');
    }
    .sign-up {
      background-image: url('~@/assets/happyBirthday/signup.png');
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/happyBirthday/homePage.vue